import React from "react";
//import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as urlService from "../../view/urlService";

function InventorySearchSection() {

    const history = useHistory();

    const onSearch = (value) => {
        history.push({
            pathname: history.pathname,
            search: value ? urlService.updateFilters('name', value) : urlService.removeFilter('name')
        })
    }

    return (
        <div className="network-scan-search-v2">
            <label className="network-scan-search-label-v2" htmlFor="inventorySearch">Filter/Search</label>
            <input
                id="inventorySearch"
                className="network-scan-search-input-v2"
                type="text"
                placeholder="Search inventory"
                aria-label="Search inventory"
                onChange={event => onSearch(event.target.value)}
            />
        </div>
    )
}


export default InventorySearchSection;
